<template>
<m-pageframe
    title="Font Settings: {organization-label}"
>
<v-container
    fluid
>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="onClickUploadFont()"
                >
                    <v-list-item-title>Upload Font...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> 
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.sample="{ item }">
            <span
                :style="styleDemoFont(item)"
            >
                Lorem ipsum dolor sit amet
            </span>
        </template>

        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical-circle-outline
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickEdit(item)"
                >
                    <v-list-item-title>Edit...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

    <m-edit-blobs-dialog
        ref="upload-blob-dialog"
        title="Upload Font"
        v-on:ok="afterUpload($event)"
        :externally_visible="true"
        :show_send_as_links="false"
        :organization_id="$route.params.organization_id"
    />

    <m-settings-organization-font-edit-dialog
        ref="edit-font-dialog"
        v-on:ok="doUpdate"
        />

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {
    data() {
        return {
            full_text: null,
            results: [],

            headers: [
                { text: 'Label', value: 'label'},
                { text: 'Fall Back', value: 'fall_back'},
                { text: 'Sample', value: 'sample'},
                { text: 'Action', value: 'action'},
            ],
        }
    },

    mounted () {
        this.doUpdate();
        this.$rc.loadCustomFonts(this.$route.params.organization_id);
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/css/font-face',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                        'full_text': this.full_text,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to search custom fonts',
            });
        },

        styleDemoFont(item)
        {
            return 'font-size: 30px; font-family: '+item.font_family_name;
        },

        onClickUploadFont()
        {
            this.$refs['upload-blob-dialog'].showDialog([],false);
        },

        afterUpload(blob_ids)
        {
            if ( blob_ids.length < 1 )
                return;

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/css/create-font',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                        'blob_id': blob_ids[0]
                    },
            
                'on_success': (data) => {
                        this.$rc.loadCustomFonts(this.$route.params.organization_id);
                        this.doUpdate();
                        this.onClickEdit(data);
                    },
            
                'on_error': 'Unable to create font',
            });
        },

        onClickEdit(item)
        {
            this.$refs['edit-font-dialog'].showDialog(item);
        },
    },
}
</script>

<style lang="scss" scoped>
</style>